import { Intercom } from '@intercom/messenger-js-sdk';

export const initIntercom = (): void => {
  Intercom({
    app_id: window.INTERCOM_ID,
    hide_default_launcher: true,
  });
};
